import {
  getCountryCurrencyData,
  getTemplateCountryCurrency,
  editDataCountryCurrency,
  getCountryCurrencyById,
  createCountryCurrency,
  deleteCountryCurrency,
  updateCountryCurrency,
} from "@/http/system/currencyExchange.js";

export default {
  namespaced: true,
  state: {
    countrycurrencyData: [],
    viewExchange: {},
  },
  actions: {
    async setCountryCurrencyData({ commit }) {
      try {
        const resp = await getCountryCurrencyData();
        commit("SET_COUNTRYCURRENCY_LIST", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getCreateTemplateCountryCurrency(_, data) {
      try {
        return await getTemplateCountryCurrency(data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async editTempleteDataCountryCurrency(_, data) {
      try {
        return await editDataCountryCurrency(data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async fetchApnZoneIdAction(_, id) {
      try {
        return await getCountryCurrencyById(id);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createCountryCurrencyAction(_, data) {
      try {
        return await createCountryCurrency(data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deleteCountryCurrencyAction(_, data) {
      try {
        return await deleteCountryCurrency(data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async updateCountryCurrencyAction(_, payload) {
      try {
        return await updateCountryCurrency(payload.id, payload.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  mutations: {
    SET_COUNTRYCURRENCY_LIST(state, payload) {
      state.countrycurrencyData = payload;
    },
    VIEW_CURRENCY_EXCHANGE(state, payload) {
      state.viewExchange = payload;
    },
  },
  getters: {
    getCountryCurrencyList(state) {
      return state.countrycurrencyData;
    },
  },
};
